type Dropdown = {
  button: HTMLElement
  panel: HTMLElement
}

function setExpanded(dropdown: Dropdown, expanded: boolean): void {
  dropdown.panel.classList.toggle("active", expanded)
  dropdown.button.setAttribute("aria-expanded", expanded ? "true" : "false")
  dropdown.panel.setAttribute("aria-hidden", expanded ? "false" : "true")
  dropdown.button.querySelector(".menu-nav__down-arrow-icon")?.classList.toggle("active", expanded)
}

export class MobileDropdowns {
  private dropdowns: Dropdown[]

  constructor() {
    this.dropdowns = Array.from(
      document.querySelectorAll<HTMLElement>(".menu-nav button[aria-controls]"),
    ).flatMap((button) => {
      const panelId = button.getAttribute("aria-controls")
      const panel = panelId ? document.getElementById(panelId) : null
      return panel ? [{ button, panel }] : []
    })

    this.syncInitialState()
    this.addEventListeners()
  }

  private syncInitialState(): void {
    this.dropdowns.forEach((dropdown) => {
      setExpanded(dropdown, dropdown.button.getAttribute("aria-expanded") === "true")
    })
  }

  private addEventListeners(): void {
    this.dropdowns.forEach((dropdown) => {
      dropdown.button.addEventListener("click", (e) => {
        e.preventDefault()
        this.toggle(dropdown)
      })
    })
  }

  private toggle(target: Dropdown): void {
    const willExpand = target.button.getAttribute("aria-expanded") !== "true"

    this.dropdowns.forEach((dropdown) => {
      setExpanded(dropdown, willExpand && dropdown === target)
    })
  }
}
